import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import Form from '@piconetworks/pkg-form'
import styles from './Menu.module.scss'

import { contributionBinPluralCapitalized, contributionBinPluralSlug } from 'features/ContributionLang'

class ProductsMobileMenu extends PureComponent {
    render() {
        const { router, showPasses, productsLoading } = this.props
        const options = [
            {
                value: 'subscriptions',
                label: 'Subscriptions',
            },
            ...(showPasses ? [{
                value: 'passes',
                label: 'Passes',
            }] : []),
            {
                value: contributionBinPluralSlug(),
                label: contributionBinPluralCapitalized(),
            },
        ]

        const value =
            typeof window !== 'undefined'
                ? window.location.pathname.slice(10)
                : ''

        if (productsLoading) {
            return (
                <section className="w-100">
                    <div className={styles.mobileDropdown}>
                    </div>
                </section>
            )
        }
        
        return (
            <section className="w-100">
                <div className={styles.mobileDropdown}>
                    <Form.Dropdown
                        input={{
                            value,
                            onChange: (e) => {
                                router.push('/products/[section]', e, {
                                    shallow: true,
                                })
                            },
                            onBlur: () => {},
                        }}
                        meta={{}}
                        options={options}
                    />
                </div>
            </section>
        )
    }
}

ProductsMobileMenu.propTypes = {
    productsLoading: PropTypes.bool,
    router: PropTypes.object,
    showPasses: PropTypes.bool,
}

export default withRouter(ProductsMobileMenu)
